document.addEventListener('DOMContentLoaded', function () {
  const scrollArea = document.querySelector(
    '.comparison-table__content.h-scrollable'
  );

  if (!scrollArea) return;

  let isDown = false;
  let startX;
  let scrollLeft;

  scrollArea.addEventListener('mousedown', (e) => {
    isDown = true;
    scrollArea.classList.add('is-dragging');
    startX = e.pageX - scrollArea.offsetLeft;
    scrollLeft = scrollArea.scrollLeft;
  });

  scrollArea.addEventListener('mouseleave', () => {
    isDown = false;
    scrollArea.classList.remove('is-dragging');
  });

  scrollArea.addEventListener('mouseup', () => {
    isDown = false;
    scrollArea.classList.remove('is-dragging');
  });

  scrollArea.addEventListener('mousemove', (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - scrollArea.offsetLeft;
    const walk = (x - startX) * 1.2; // 드래그 감도
    scrollArea.scrollLeft = scrollLeft - walk;
  });
});

